import React, { Component } from 'react';
import {
    Link
} from "react-router-dom";
import { Formik } from 'formik';
import _ from 'lodash';
import config from '../config';
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
export default class User extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {
            query: {},
            visibleColumns: []
        };
        this.find = this.find.bind(this);
        this.getUserList = this.getUserList.bind(this);
        this.toggleColumn = this.toggleColumn.bind(this);
    }

    componentDidMount() {
        // Загружаем начальные данные при монтировании
        const query = new URLSearchParams(this.props.location.search);
        const newQuery = {
            page: query.get("page") || 0
        };
        this.getUserList(newQuery);
        this.loadColumnSettings();
    }

    loadColumnSettings() {
        // Загружаем настройки столбцов из localStorage
        const savedColumns = localStorage.getItem('userTableColumns');
        console.log(savedColumns);
        if (savedColumns) {
            this.setState({ visibleColumns: JSON.parse(savedColumns) });
        }
    }

    saveColumnSettings() {
        // Сохраняем настройки столбцов в localStorage
        localStorage.setItem('userTableColumns', JSON.stringify(this.state.visibleColumns));
    }

    toggleColumn(columnKey) {
        // Переключаем видимость столбца
        this.setState(prevState => {
            const visibleColumns = prevState.visibleColumns.includes(columnKey)
                ? prevState.visibleColumns.filter(key => key !== columnKey)
                : [...prevState.visibleColumns, columnKey];
            return { visibleColumns };
        }, this.saveColumnSettings);
    }

    getUserList(query)  {
        fetcher(`${config.API()}collection/user-save-vars`)
            .then(response => response.json())
            .then(data => {
                this.vars = data;
            });

        fetcher(`${config.API()}users?` + new URLSearchParams(Object.assign({
            page: 0
        }, query)))
            .then(response => response.json())
            .then(data => {
                this.setState({query: query, items: data.items, total: data.total})
            }).catch(function(err) {});

    }


    find(values)  {
        const id = (values.id || '').trim();
        if (id) {
            this.props.history.push("/users/"+encodeURIComponent(id))
        }
    }
    removeUser(values)  {
        fetch(`${config.API()}users/remove/${values.id}`, {cache:"no-cache", 'Authorization': this.authContext.authToken})
            .then(response => response.json())
            .then(data => {
                this.props.history.push("/users")
            }).catch(function(err) {
        });
    }
    render() {
        const query = new URLSearchParams(this.props.location.search);
        let newQuery = {
            page: query.get("page") || 0
        }

        if (!_.isEqual(newQuery, this.state.query)) {
            this.getUserList(newQuery);
            return (<div></div>);
        }

        let pages = []
        let page = parseInt(this.state.query.page) || 0
        let lastPage = Math.floor(this.state.total / 100)

        if(page == 0) {
            pages.push(page)
            if(page+1 <= lastPage)
                pages.push(page+1)
            if(page+2 <= lastPage)
                pages.push(page+2)
        }else if(page == lastPage){
            if(page-2 >=0)
                pages.push(page-2)
            if(page-1 >=0)
                pages.push(page-1)
            pages.push(page)
        }else{
            if(page-1 >=0)
                pages.push(page-1)
            pages.push(page)
            if(page+1 <= lastPage)
                pages.push(page+1)
        }

        return (
            <div>
            <div className="card shadow w100">
                <div className="card-header py-3"><h2 className="m-0 font-weight-bold"> Users </h2> </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col col-6">
                            <Formik
                                initialValues={{ id: ''}}
                                onSubmit= {this.find}
                            >
                                {({
                                      values,
                                      handleSubmit,
                                      handleChange,
                                      isSubmitting
                                  }) => (
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-row align-items-center">
                                            <div className="col-6">
                                                <input className="form-control"
                                                       type="text"
                                                       name="id"
                                                       placeholder="userId or deviceId"
                                                       onChange={handleChange}
                                                       value={values.id}
                                                />
                                            </div>
                                            <div className="col-auto">
                                                <button  type="submit" className="btn btn-icon btn-success ml-1" >
                                                    <span className="fas fa-fw fa-search"></span> FIND
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="r p-2 pr-4">
                                <ul className="pagination">
                                    <li className={"page-item " + (page == 0 ? "disabled" : "")}>
                                        {page != 0 && <Link className="page-link" to={"/users?"+ new URLSearchParams(Object.assign(newQuery, {page:page-1}))}>Previous</Link>}
                                        {page == 0 && <span className="page-link">Previous</span>}
                                    </li>
                                    { pages.map((p,i) =>
                                        <li key={`p`+p} className={`page-item ${page == p ? "active" : ""}`}>
                                            <Link className="page-link" to={"/users?" + new URLSearchParams(Object.assign(newQuery, {page:p}))}>{ p+1 }</Link>
                                        </li>
                                    )}
                                    <li className={"page-item " + (page == lastPage ? "disabled" : "")}>
                                        {page != lastPage && <Link className="page-link" to={"/users?"+ new URLSearchParams(Object.assign(newQuery, {page:page+1}))}>Next</Link>}
                                        {page == lastPage && <span className="page-link">Next</span>}
                                    </li>
                                </ul>
                            </div>
                            <div className="r p-2 pr-4 pt-3">Showing {page+1} to {lastPage+1} of {this.state.total} users</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex flex-wrap">
                                {this.vars && this.vars
                                    .filter(varItem => varItem.key !== "deviceId")
                                    .map(varItem => (
                                    <div key={varItem.key} className="form-check mr-2 small">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`column-${varItem.key}`}
                                            checked={this.state.visibleColumns.includes(varItem.key)}
                                            onChange={() => this.toggleColumn(varItem.key)}
                                        />
                                        <label className="form-check-label" htmlFor={`column-${varItem.key}`}>
                                            {varItem.key}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                               cellSpacing="0">
                            <thead>
                            <tr>
                                <th>userId</th>
                                <th>deviceId</th>
                                {this.vars
                                    .filter(varItem => varItem.key !== "deviceId" && this.state.visibleColumns.includes(varItem.key))
                                    .map(varItem => (
                                        <th key={varItem.key}>{varItem.key}</th>
                                    ))}
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items && this.state.items.map((x,i) =>
                                <tr
                                    key={`h`+x._id}
                                    onClick={(e => this.find({id: x._id}))}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>
                                        <Link to={`/users/${encodeURIComponent(x._id)}`}>{x._id}</Link>
                                    </td>
                                    <td>{x.deviceId || ''}</td>
                                    {this.vars
                                        .filter(varItem => varItem.key !== "deviceId" && this.state.visibleColumns.includes(varItem.key))
                                        .map(varItem => (
                                            <td key={varItem.key}>{_.get(x, varItem.value)}</td>
                                        ))}
                                    <td>

                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            </div>
        );
    }
}
